module.exports = __webpack_public_path__ + "static/media/AU Research Roster - 2f - renamed Class Length column.cdcf0334.csv";